const s = {
  name: "Calculator",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9.5,11.5H6v-2h3.5V6h2v3.5H15v2h-3.5V15h-2V11.5z"/>
		<path class="st0" d="M28.1,10.5l-2.8-2.8l1.4-1.4l2.8,2.8l2.8-2.8l1.4,1.4l-2.8,2.8l2.8,2.8l-1.4,1.4l-2.8-2.8l-2.8,2.8l-1.4-1.4
			L28.1,10.5z"/>
		<path class="st0" d="M15,30.5H6v-2h9V30.5z"/>
		<path class="st0" d="M25,30.5h9v-2h-9V30.5z"/>
		<path class="st0" d="M29.5,27c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C28.2,26.4,28.8,27,29.5,27z"/>
		<path class="st0" d="M30.7,33.2c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C30.2,32,30.7,32.6,30.7,33.2z"/>
		<path class="st0" d="M40,37c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3h34c1.7,0,3,1.3,3,3V37z M2,3v16h17V2H3
			C2.5,2,2,2.5,2,3z M21,19h17V3c0-0.5-0.5-1-1-1H21V19z M19,38V21H2v16c0,0.5,0.5,1,1,1H19z M21,38h16c0.5,0,1-0.5,1-1V21H21V38z"
			/>
	</g>
</g>
</svg>
  `
};
export {
  s as Calculator
};
